import classNames from 'classnames';
import { useField } from 'formik';

import useInput from '../hooks/useInput';

type PropsFormikRadio = {
  id?: string;
  name: string;
  value?: string;
  label: string;
  classInput?: string;
  className?: string;
  disabled?: boolean;
  inputProps?: object;
  onClick?: () => void;
  onChange?: () => void;
}

export function FormikRadio(
  {
    id: defaultId,
    name,
    value,
    label,
    classInput,
    className,
    disabled = false,
    inputProps = {},
    onClick = () => (false),
    onChange = () => (false)
  }: PropsFormikRadio
) {
  const [field, meta] = useField({
    name,
    value,
    type: 'radio'
  });
  const { id } = useInput(defaultId, label);
  const handleChange = (e)=>{
    // @ts-ignore
    onChange(e.target.value);
    field.onChange(e);
  }
  return (
    <div
      className={classNames(
        'form-check form-check-inline',
        className
      )}
    >
      <input
        id={id}
        className={classNames(
          'form-check-input',
          meta.touched && meta.error && 'is-invalid'
        )}
        type="radio"
        disabled={disabled}
        {...inputProps}
        {...field}
        onClick={onClick}
        onChange={handleChange}
      />
      <label
        className="form-check-label"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}

export default FormikRadio;
